import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../utils/axios";

export default function EventPaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const paymentIntentId = searchParams.get("payment_intent");
  const redirectStatus = searchParams.get("redirect_status");

  useEffect(() => {
    const verifyPayment = async () => {
      if (redirectStatus === "succeeded" && paymentIntentId) {
        try {
          // Call your backend to confirm the payment and finalize event booking
          const response = await axiosInstance.post("/news_and_events/event-payment-confirmation/", {
            payment_intent_id: paymentIntentId,
          });

          toast.success("Payment successful! Redirecting to your ticket...");
          console.log("response after booking ===> ", response.data);

          // Redirect to your beautiful EventBookingSuccessPage with full data
          setTimeout(() => {
            console.log("response after booking ===> ", response.data);
            navigate("/event-booking-success", { state: response.data });
          }, 2000);
        } catch (error) {
          console.error("Event booking confirmation failed:", error);
          toast.error("Payment succeeded but booking confirmation failed. Please contact support.");
          setTimeout(() => navigate("/"), 3000);
        }
      } else {
        // Failed or cancelled
        toast.error("Payment failed or was cancelled.");
        setTimeout(() => navigate("/"), 3000);
      }
    };

    verifyPayment();
  }, [paymentIntentId, redirectStatus, navigate]);

  const isSuccess = redirectStatus === "succeeded";

  return (
    <div className="container text-center py-5 min-vh-100 d-flex align-items-center justify-content-center">
      <div className="card shadow-lg p-5" style={{ maxWidth: "500px", width: "100%" }}>
        {/* Spinner */}
        <div className="mb-4">
          <div
            className="spinner-border text-primary"
            role="status"
            style={{ width: "4rem", height: "4rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>

        {/* Title */}
        <h1 className={`display-5 fw-bold mb-3 ${isSuccess ? "text-success" : "text-danger"}`}>
          {isSuccess ? "Processing Payment..." : "Payment Failed"}
        </h1>

        {/* Message */}
        <p className="lead text-muted mb-4">
          {isSuccess
            ? "We're confirming your event booking and preparing your ticket..."
            : "Your payment could not be completed."}
        </p>

        {/* Extra Info */}
        {isSuccess && (
          <div className="alert alert-success" role="alert">
            <strong>Success!</strong> You will be redirected to your ticket in a moment.
          </div>
        )}

        {!isSuccess && (
          <div className="alert alert-danger" role="alert">
            <strong>Failed</strong> Please try again or contact support.
          </div>
        )}

        {/* Back Button */}
        <button
          className="btn btn-outline-secondary btn-lg mt-4"
          onClick={() => navigate("/")}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}
